import TasksView_Settings from "../settings"
import {AppSettingsMode} from "../../../../../manager/app-settings/app-settings"
// import {getObjectsDifference} from "../../../../../gd/utils/misc/get-objects-difference"

// const debug = "tasksView_Settings_isConfigChanged"
const debug = false

export default function tasksView_Settings_isConfigChanged(settings: TasksView_Settings, omittedParams: any[] = []) {
    debug && console.log(debug, "isConfigChanged() omitParams=", omittedParams)

    let res : boolean

    switch (settings.mode) {
        case AppSettingsMode.INHERITED:
            res = false
            break

        case AppSettingsMode.TEMPLATE:
            const configJSON : any = _.omit(settings.configToJSON(), omittedParams)
            debug && console.log("    this is template case")
            res = configJSON.templateId !== _.get(settings._storedAppSettingsConfig, 'templateId', null)
            break

        case AppSettingsMode.CUSTOM:
        default:
            const omitted = ['templateId', 'version'].concat(omittedParams)
            const currentConfigJSON = _.omit(settings.configToJSON(), omitted)
            const initialConfigJSON = _.omit(settings.normalizeConfig2(settings._storedAppSettingsConfig || {}), omitted)

            debug && console.log("    initialConfig before normalization = ", settings._storedAppSettingsConfig)
            debug && console.log("    initial=", initialConfigJSON)
            debug && console.log("    current=", currentConfigJSON)

            res = !_.isEqual(currentConfigJSON, initialConfigJSON)

            // console.log("    diff=", getObjectsDifference(currentConfigJSON, initialConfigJSON))
    }

    debug && console.log("    hasChanged=", res)

    return res;
}